import { FormControlLabel, FormGroup, Switch } from '@mui/material';
import { FieldProp } from 'react-typed-form';

type Props = {
  field: FieldProp<boolean>;
  label?: string;
  forceDisabled?: boolean;
  disabled?: boolean;
  labelPlacement?: 'start' | 'end';
};

export default function FieldSwitch({
  field,
  label,
  forceDisabled,
  disabled,
  labelPlacement = 'start',
}: Props) {
  return (
    <FormGroup>
      <FormControlLabel
        sx={{
          '& .MuiFormControlLabel-label': {
            typography: 'body2',
            color: 'text.secondary',
          },
        }}
        control={
          <Switch
            checked={field.value}
            onChange={(_e, checked) => field.handleValueChange(checked)}
            disabled={field.isLoading || forceDisabled || disabled}
          />
        }
        label={label ?? field.label}
        labelPlacement={labelPlacement}
      />
    </FormGroup>
  );
}
